import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const FileExplorerTranslatableNames = [
  "Organization",
  "Event",
  "SeaSurvey",
  "MapArea",
  "Design material",
  "Map 3D Objects",
  "/",
];

type ReturnProps = {
  translateNodeName: (name?: string) => string | undefined;
};

const useFileTranslations = (): ReturnProps => {
  const { t } = useTranslation("file-explorer-translations");

  const translateNodeName = useCallback(
    (name?: string) => {
      if (name === "/") {
        return t("root").toString();
      }
      return name && FileExplorerTranslatableNames.includes(name)
        ? t(name.replace(/ /gm, "-").toLowerCase()).toString()
        : name;
    },
    [t],
  );

  return { translateNodeName };
};

export default useFileTranslations;
